<app-customer-header></app-customer-header>
<div class="container track-details">
  <div class="row">
    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
      <div class="truck-left" *ngIf="trips_track">
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/dashboard.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToDashboard()">Dashboard</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trip.svg" alt="" />
          </div>
          <div class="truck-left-details" (click)="GoToBookATrips()">
            <h5>Book a Trip</h5>
          </div>
        </div>
        <div class="dashboard-menu active">
          <div class="truck-left-icon">
            <img src="assets/img/trips.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToTrips()">Trips</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon" (click)="help()">
            <img src="assets/img/help.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Help</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12" *ngIf="trips_track">
      <div class="trip-acoordion">
        <div class="dash-trucks-top1">
          <a [ngClass]="{ active: tripType == '-1' }" (click)="getTripsList('-1')">All</a>
          <a [ngClass]="{ active: tripType == 'liveTrips' }" (click)="getTripsList('liveTrips')">Live Trips</a>
          <a [ngClass]="{ active: tripType == 'upcoming' }" (click)="getTripsList('upcoming')">UpComing</a>
          <a [ngClass]="{ active: tripType == 'completed' }" (click)="getTripsList('completed')">Completed</a>
          <a [ngClass]="{ active: tripType == 'cancelled' }" (click)="getTripsList('cancelled')">Cancelled</a>
          <a [ngClass]="{ active: tripType == 'quotes' }" (click)="getTripsList('quotes')">Quotes</a>
          <a [ngClass]="{ active: tripType == 'quoteCancel' }" (click)="getTripsList('quoteCancel')">Cancelled Quote</a>
        </div>

        <div class="dash-trucks-top2">
          <button
            type="button"
            *ngIf="searchButton"
            class="button search-btn"
            (click)="openSearch()"
          >
            <img src="assets/img/search-white.svg" />
          </button>
          <div *ngIf="toggleSearch" class="search_toggle">
            <input
              uppercase
              class="search"
              placeholder="Trip ID"
              id="searchtripID"
              #newItem
              (keyup)="onInputChange(newItem)"
              (keyup.enter)="isInputValid && search(newItem.value)"
            />
            <button
              [disabled]="!isInputValid"
              *ngIf="search_Btn"
              class="search_number"
              (click)="search(newItem.value)"
            >
              <img src="assets/img/search-white.svg" />
            </button>
            <button
              type="button"
              class="search_number1"
              *ngIf="cancelSearchButton"
              (click)="cancelSearch()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
              >
                <path
                  d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div [class.spinner]="tripsloading"></div>
      <div class="row to_container" *ngIf="!trips?.length && !tripsloading">
        <h4 class="error_msg">No Records Found.</h4>
      </div>
      <div *ngIf="trips?.length && !tripsloading">
        <form *ngFor="let item of trips; let i = index">
          <div class="trips-page mt-3">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12">
                <div class="row trip-view-top">
                  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 trip-view-top-left">
                    <img src="assets/img/trip.svg" alt="" />
                    <h6>{{ item.trip_id }}</h6>
                  </div>
                  <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 trip-view-top-right">
                    <div class="trip-top-right-top">
                      {{ item.truck_type[0].truck_feet }} Truck
                    </div>
                    <div class="trip-top-right-middle">
                      <span class="location-1">{{
                        item.pickup_details.from_city_name
                        }}</span>
                      <span class="location-img"><img src="assets/img/trip-location.svg" alt="" /></span>
                      <span class="location-2">{{
                        item.dropoff_details.to_city_name
                        }}</span>
                    </div>
                    <div class="trip-top-right-bottom">
                      Load: {{ item.material_type }}
                    </div>
                  </div>
                </div>
                <div class="trip-view-bottom">
                  <div class="trips-amount">
                    <a>Paid Amount:</a>
                    <div>
                      <p>
                        ₹
                        {{
                        item.payment_details[0]?.price_details
                        ?.payment_history
                        ? (
                        (item.payment_details[0]?.price_details
                        ?.payment_history[0]?.amount_paid || 0) +
                        (item.payment_details[0]?.price_details
                        ?.payment_history[2]?.amount_paid || 0)
                        ).toFixed(2)
                        : ""
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="billing-amount">
                    <a>Balance Amount:</a>
                    <div>
                      <p>
                        ₹
                        {{
                        item.payment_details[0]?.price_details
                        ?.payment_history
                        ? (
                        item.payment_details[0]?.price_details
                        ?.total_amount -
                        (item.payment_details[0]?.price_details
                        ?.payment_history[0]?.amount_paid +
                        item.payment_details[0]?.price_details
                        ?.payment_history[2]?.amount_paid)
                        ).toFixed(2)
                        : ""
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="billing-amount">
                    <a>Billing Amount:</a>
                    <div>
                      <p>
                        ₹
                        {{
                        (item.payment_details[0]?.price_details?.total_amount).toFixed(
                        2
                        )
                        }}
                        <span *ngIf="item.trip_status === 'quoteBooked'">
                          {{item.driver_route_info?.[0]?.price}} +taxes
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="billing-amount">
                    <a>Date:</a>
                    <div>
                      <p>{{ item.pickup_date | date : "dd-MM-yyyy" }}</p>
                    </div>
                  </div>
                  <div class="billing-amount">
                    <a>Weight:</a>
                    <div>
                      <p>{{ item.truck_type[0]?.truck_weight }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                <div class="trip-view-left">
                  <button class="trip-btn" [ngClass]="{
                      active: viewTripIndex === item ? tripType == 'quote' : ''
                    }" (click)="getTripsList('-1')" (click)="GoToTripDetails(item)">
                    <img src="assets/img/eye.svg" alt="" /> View Details
                  </button>

                  <button class="trip-btn" [ngClass]="{
                      active: viewTripIndex === i ? tripType == 'quotes' : ''
                    }" (click)="getTripsList('quotes')" (click)="cancelQuote(item)" *ngIf="
                      item.trip_status != 'cancelled' &&
                      item.trip_status != 'completed' &&
                      item.trip_status != 'quoteCancel' &&
                      item.trip_status != 'tripbooked' &&
                      item.trip_status != 'tripstarted' &&
                      item.trip_status != 'quoteBooked' &&
                      item.trip_status != 'inprogress'
                    ">
                    <img src="assets/img/cross.svg" alt="" />Cancel Quote
                  </button>
                  <button class="trip-btns" [ngClass]="{
                      active: viewTripIndex === i ? tripType == 'quotes' : ''
                    }" *ngIf="
                      item.trip_status != '-1' &&
                      item.trip_status != 'quote' &&
                      item.trip_status != 'tripstarted' &&
                      item.trip_status != 'tripbooked' &&
                      item.trip_status != 'completed' &&
                      item.trip_status != 'quoteBooked' &&
                      item.trip_status != 'inprogress'
                    ">
                    <img src="assets/img/cross.svg" alt="" /> Quote has
                    Cancelled
                  </button>
                  <button class="trip-btn" [ngClass]="{
                      active: cancelTripIndex === i ? tripType == 'cancel' : ''
                    }" (click)="getTripsList('cancel')" (click)="GoToCancelTrip(i, item.trip_status)" *ngIf="
                      (item.trip_status != 'cancelled' &&
                        item.trip_status == 'tripbooked') ||
                      item?.trip_status == 'tripbooked'
                    ">
                    <img src="assets/img/cross.svg" alt="" />Cancel Trip
                  </button>
                  <!-- <button
                    class="trip-btn"
                    [ngClass]="{
                      active: cancelTripIndex === i ? tripType == 'quote' : ''
                    }"
                    *ngIf="item.trip_status === 'quote'"
                  >
                    <img src="assets/img/searchs.svg" alt="" />Search for Truck
                  </button> -->

                  <button type="button" class="trip-btn" [ngClass]="{
                      active:
                        payNowTripIndex === i ? tripType == 'paybalance' : ''
                    }" (click)="getTripsList('paybalance')" (click)="payNow(i, item.payment_details[0], item)" *ngIf="
                      item.payment_details[0]?.payment_status == 'not-paid'
                    ">
                    <img src="assets/img/rupee-black.svg" alt="" />Pay Now
                  </button>
                  <button class="trip-btn" [ngClass]="{
                      active: payNowTripIndex === i && tripType === 'paybalance'
                    }" (click)="getTripsList('paybalance')" (click)="payBalance(i, item.payment_details[0], item)"
                    *ngIf="
                      item.trip_status !== 'cancelled' &&
                      (item.trip_status === 'inprogress' ||
                        item.trip_status === 'tripbooked' ||
                        item.trip_status === 'tripstarted') &&
                      item.payment_details[0]?.payment_status === 'partial-paid'
                    ">
                    <img src="assets/img/rupee-black.svg" alt="" />Pay Balance
                  </button>

                  <button class="trip-btn" [ngClass]="{ active: tripType == 'consignment' }" *ngIf="
                      item.trip_status === 'completed' &&
                      (item.payment_details[0]?.payment_status ==
                        'fully-paid' ||
                        item.payment_details[0]?.payment_status ==
                          'partial-paid')
                    " (click)="consignNote(item)">
                    <img src="assets/img/file-invoice-solid.svg" alt="" style="width: 14%" />Consignment Cum Invoice
                  </button>
                  <button class="trip-btn" [ngClass]="{ active: tripType == 'quoteBooked' }"
                    (click)="GoToTruckLoadDetails(item)" *ngIf="item.trip_status == 'quoteBooked'">
                    Truck Available,<br />
                    Pay 10%
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="track" *ngIf="item.live_track">
                  <div (click)="liveTrack(item._id)" *ngIf="
                      (item.trip_status != 'completed' &&
                        item.trip_status != 'cancelled' &&
                        item.trip_status != 'tripbooked') ||
                      (item.trip_status == 'inprogress' &&
                        item.payment_details[0]?.payment_status == 'fully-paid')
                    ">
                    Track
                  </div>
                </div>
                <div class="quote-status-bar" *ngIf="item.trip_status === 'quote'" [ngClass]="{'has-bid': item.lowest_bid_price}">
                  <div *ngIf="item.lowest_bid_price; else noBidTpl" class="quote-active-state">
                    
                    <div class="quote-info-engaging">
                      <div class="quote-price-block">
                        <span class="quote-label">Current Lowest Bid</span>
                        <span class="quote-price">₹{{ item.lowest_bid_price | number:'1.0-0' }}</span>
                      </div>
                      
                      <div class="quote-timer-block" *ngIf="item.quote_expiry_time && item.countdownTimer !== 'Expired'">
                         <div class="pulsing-dot"></div>
                         <span>Confirms in: <strong>{{ item.countdownTimer }}</strong></span>
                      </div>
                      
                      <div class="quote-expired-block" *ngIf="item.countdownTimer === 'Expired'">
                        <i class="fa fa-exclamation-circle"></i> Quote Expired
                      </div>
                    </div>
                    
                    <button class="btn-book-engaging" (click)="acceptQuote(item._id)" *ngIf="item.countdownTimer !== 'Expired'">
                      Confirm Now <i class="fa fa-arrow-right"></i>
                    </button>
                  </div>
                  <ng-template #noBidTpl>
                    <div class="quote-waiting-state">
                      <i class="fa fa-spinner fa-spin"></i> We are currently arranging a suitable truck for your trip...
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div class="trip-cancel-container" *ngIf="cancelTrip && cancelTripIndex === i">
            <form>
              <div class="trip-detail-popup-right">
                <img src="assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
              </div>
              <div class="trip-cancel">
                <p>Refund Summary</p>
                <mat-divider></mat-divider>
                <div class="card-details card-details-total">
                  <div class="trip-details-left">Booking Amount</div>
                  <div class="trip-details-right">
                    ₹
                    {{
                    this.trips[this.cancelTripIndex].payment_details[0]
                    .price_details.actual_price
                    }}
                  </div>
                  <div class="trip-details-left">Deductions</div>
                  <div class="trip-details-right"></div>
                  <div *ngFor="let item of taxDetails">
                    <div class="trip-details-left">
                      {{ item.tax_name }}
                      {{ item.tax_deduction | number : "1.2-2" }}
                      {{ item.tax_type == "percent" ? "%" : "₹" }}
                    </div>
                    <div class="trip-details-right trip_details" *ngIf="item.tax_type == 'percent'">
                      ₹
                      {{
                      (this.trips[this.cancelTripIndex].payment_details[0]
                      .price_details.actual_price *
                      item.tax_deduction) /
                      100 | number : "1.2-2"
                      }}
                    </div>
                  </div>
                </div>
                <mat-divider></mat-divider>
                <div class="card-details-container">
                  <div class="refund-amount-left">Refund Amount</div>
                  <div class="refund-amount-right">
                    ₹
                    {{ totalReceivable | number : "1.2-2" }}
                  </div>
                  <div class="refund-cancel">
                    <div class="refund-reasons">Reasons for cancellation</div>
                    <div class="refund-reasons-radio">
                      <mat-radio-group>
                        <mat-radio-button value="1" (click)="transporter()">I have a better deal from other website or
                          transporter
                        </mat-radio-button>
                        <mat-radio-button value="2" (click)="cancel()">My trip has been postponed or cancelled
                        </mat-radio-button><br />
                        <mat-radio-button value="3" (click)="others()">Others</mat-radio-button>
                      </mat-radio-group>
                      <div class="">
                        <button type="button" class="button buttonBlue fixed-btn" (click)="tripCancel(item._id)">
                          Cancel Trip
                        </button>
                      </div>
                    </div>
                  </div>
                  <form [formGroup]="cancelReasonForm">
                    <div class="refund-cancel-right" *ngIf="otherTrips">
                      <textarea name="" id="" rows="4" formControlName="otherDetails"
                        placeholder="Enter the cancellation reason"></textarea>
                    </div>
                    <div class="refund-cancel-right" *ngIf="transporterTrips">
                      <textarea rows="4" formControlName="transportDetails"
                        placeholder="Enter the Website or Transporter name"></textarea>
                    </div>
                  </form>
                </div>
              </div>
            </form>
          </div>
        </form>
      </div>

      <div *ngIf="last_page && last_page > 1" class="pagination">
        <button class="btn" [disabled]="fetch_page == 1">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2" (click)="pagination('-1')">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button class="btn" [disabled]="fetch_page == 1">
          <img src="../../../assets/img/pagination-left.svg" (click)="pagination('first')" alt="" class="btn--icon" />
        </button>
        <div class="pages">
          <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
        </div>
        <button class="btn" [disabled]="last_page == fetch_page">
          <img src="../../../assets/img/pagination-right.svg" (click)="pagination('last')" alt="" class="btn--icon" />
        </button>
        <button class="btn" [disabled]="last_page == fetch_page">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2" (click)="pagination('1')">
            <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>

    <!-- ---------------------- Map ------------------------- -->

    <div style="display: flex">
      <div class="truck-left2" *ngIf="!trips_track">
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/dashboard.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToDashboard()">Dashboard</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trip.svg" alt="" />
          </div>
          <div class="truck-left-details" (click)="GoToBookATrips()">
            <h5>Book a Trip</h5>
          </div>
        </div>
        <div class="dashboard-menu active">
          <div class="truck-left-icon">
            <img src="assets/img/trips.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToTrips()">Trips</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon" (click)="help()">
            <img src="assets/img/help.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Help</h5>
          </div>
        </div>
      </div>
      <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12" *ngIf="!trips_track">
        <div class="row" *ngIf="!trips_track">
          <div class="col-md-9"></div>
          <div class="col-md-2 align-self-end">
            <button type="button" class="btn btn-danger close-tracking mb-2" (click)="closeTracking()">
              Close Tracking
            </button>
          </div>
        </div>
        <!-- <div class="hide" *ngIf="isLoading">
          <div class="loader"></div>
        </div> -->
        <div class="loader-container" *ngIf="isLoading">
          <div class="circle-dot-loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>

        <app-map-tracker [curLoc]="curLoc" [routeSegments]="trackArray?.routeSegments"
          (truckTrackDtlsEvent)="openModal(trackArray)"></app-map-tracker>
        <div class="OTP" *ngIf="trackArray?.customerCode?.code">
          <div class="row">
            <div class="col-md-12">
              <a>OTP:</a>
              {{ trackArray?.customerCode?.code }}
            </div>
          </div>
        </div>

        <div class="row mt-3 mb-4 px-5" *ngIf="!showFullTracking">
          <div class="col-md-12">
            <button type="button" class="btn btn-primary w-100 d-flex justify-content-center align-items-center"
              style="background-color: #0d6efd; border-radius: 8px; padding: 12px; font-weight: bold; color: white;"
              (click)="viewFullTracking()" [disabled]="isFullTrackingLoading">
              <i class="fa fa-map-marker" style="margin-right: 8px; font-size: 1.2rem;"></i>
              {{ isFullTrackingLoading ? 'Loading Full Tracking...' : 'View Full Tracking' }}
            </button>
          </div>
        </div>
        <div class="trip_status px-5">
          <div class="row">
            <div class="col-md-6 d-flex">
              <ul class="tripDetails">
                <li><label>Trip ID:</label> {{ trackArray?.trip_id }}</li>
                <li>
                  <label>Truck Number:</label>
                  {{ trackArray?.truckInfo?.truck_number || data?.vehicleNumber || '--' }}
                </li>
                <li>
                  <label>Location:</label>
                  {{ data?.address || '--' }}
                </li>
                <li>
                  <label>Last Updated Date:</label>
                  {{ (data?.endTrackDateTime || data?.trackDateTime) ? ((data?.endTrackDateTime || data?.trackDateTime)
                  | date : "dd MMMM yyyy, hh:mm:ss a") : '--' }}
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="tripDetails">
                <li>
                  <label>Truck Owner Name:</label>
                  {{ trackArray?.truckOwnerInfo?.username || trackArray?.truckownerDetails?.username }}
                </li>
                <li>
                  <label>Truck Owner Number:</label>
                  {{ trackArray?.truckOwnerInfo?.mobile || trackArray?.truckownerDetails?.mobile }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" id="myModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title trip">{{ trackArray?.trip_id }}</h4>
            <button type="button" (click)="closeModel()" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="name">Trip Date</div>
                {{ trackArray?.trip_start | date : "dd-MM-yyyy" }}
              </div>
              <div class="col-md-6">
                <div class="name">Driver Name:</div>
                {{ trackArray?.driverInfo?.username || trackArray?.driverDetails?.username }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="name">Driver Number:</div>
                {{ trackArray?.driverInfo?.mobile || trackArray?.driverDetails?.mobile }}
              </div>
              <div class="col-md-6">
                <div class="name">Truck Number:</div>
                {{ trackArray?.truckInfo?.truck_number || data?.vehicleNumber || '--' }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="name">Lat:</div>
                {{ data?.latitude }}
              </div>
              <div class="col-md-6">
                <div class="name">Long:</div>
                {{ data?.longitude }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="name">Last Updated</div>
                {{ (data?.endTrackDateTime || data?.trackDateTime) ? ((data?.endTrackDateTime || data?.trackDateTime) |
                date : "dd MMMM yyyy, hh:mm:ss a") : '--' }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="name">Location</div>
                {{ data?.address || '--' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>